import { Box } from '@chakra-ui/react'
import { CreditCardForm } from '@!/components/CreditCard/components'
import { PrimaryButton } from '@!/components/Button'
import { PageBackLink } from '@!/User/Payment/components'

const NewCard = ({ onSubmit, pageBack }) => (
  <Box maxW="600px" m="auto" pt="8">
    <Box p="4">
      <CreditCardForm onSubmit={onSubmit}>
        <PrimaryButton type="submit" fontSize="lg" mt="5">
          確認画面へ
        </PrimaryButton>
      </CreditCardForm>
    </Box>
    <PageBackLink pageBack={pageBack} />
  </Box>
)

export default NewCard
